
import React from "react";
import { Button } from "@/components/ui/button";
import { Info, Upload } from "lucide-react";
import { Requirement } from "@/types/project";

interface RequirementActionsProps {
  requirement: Requirement;
  onViewGuidance: (requirement: Requirement) => void;
  onUploadDocumentation: (requirement: Requirement) => void;
}

export function RequirementActions({
  requirement,
  onViewGuidance,
  onUploadDocumentation
}: RequirementActionsProps) {
  return (
    <div className="flex items-center space-x-2">
      <Button 
        variant="outline" 
        size="icon" 
        onClick={() => onViewGuidance(requirement)}
        title="View guidance"
      >
        <Info className="h-4 w-4" />
      </Button>
      <Button 
        variant="outline" 
        size="icon" 
        onClick={() => onUploadDocumentation(requirement)}
        title="Upload documentation"
      >
        <Upload className="h-4 w-4" />
      </Button>
    </div>
  );
}
